import React, { HTMLProps } from "react";

export const UndoIcon: React.FC<HTMLProps<SVGSVGElement>> = (props) => (
  <svg version="1.1" viewBox="0 0 512 512" fill="currentColor" {...props}>
    <path
      d="M263.1,168.2c-66.2,0-126,24.4-172.5,64.6L0,146.1v219.8h226.1l-90.6-88.2c34.7-29.1,78.8-47.3,127.6-47.3
   c88.2,0,163.8,55.1,189.8,134.7l59.1-16.5C477.3,243.8,378.9,168.2,263.1,168.2L263.1,168.2z"
    />
  </svg>
);
